export default __webpack_public_path__ + "static/media/icon-spinner.7932e858.svg";